import { render, staticRenderFns } from "./Colors.vue?vue&type=template&id=253e3ee7&"
import script from "./Colors.vue?vue&type=script&lang=js&"
export * from "./Colors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports